// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"a0a5c7a0","3307":"a0a5c7a0","4964":"a0a5c7a0","7934":"a0a5c7a0","8498":"a0a5c7a0"}[chunkId] + ".chunk.css";
};